import Platform from "react-native-web/dist/exports/Platform";
/**
 * Determines if the current device supports touch interactions
 *
 * @returns {boolean} True if the device supports touch, false otherwise
 */
const isTouchDevice = () => {
  if (Platform.OS !== 'web') {
    return true;
  }
  if (typeof window !== 'undefined') {
    if ('ontouchstart' in window) {
      return true;
    }
    if (window.navigator && window.navigator.maxTouchPoints > 0) {
      return true;
    }
    if (window.navigator && window.navigator.msMaxTouchPoints > 0) {
      return true;
    }
    if (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) {
      return true;
    }
  }
  return false;
};
export default isTouchDevice;